import React from 'react';
import styled from 'styled-components';

import { Button, DialogTitle, TableCell, Typography, withStyles } from '@material-ui/core';

export const HeaderTableCell = withStyles({
    head: {
        color: 'white',
        backgroundColor: 'rgb(14, 74, 100)',
        whiteSpace: 'nowrap'
    },
    root: {
        padding: '0.5rem'
    }
})(TableCell);

export const SectionTableCell = withStyles({
    head: {
        color: 'white',
        backgroundColor: 'rgb(213, 117, 48)',
        whiteSpace: 'nowrap'
    },
    root: {
        padding: '0.5rem'
    }
})(TableCell);

export const BodyTableCell = withStyles({
    root: {
        wordWrap: 'break-word',
        padding: '0.5rem'
    }
})(TableCell);

export const FlexDialogTitle = styled(DialogTitle)`
    display: flex;
    justify-content: space-between;
`;

export const OrangeSpan = styled.span` color: rgb(213, 117, 48); `;
export const RedSpan = styled.span` color: rgb(165, 35, 47); `;

export const MainDiv = styled.div` color: rgb(14, 74, 100); `;
export const SubDiv = styled.div` color: rgb(145, 145, 145); `;

export const RedDiv = styled.div` color: rgb(165, 35, 47); `;
export const OrangeDiv = styled.div` color: rgb(213, 117, 48); `;
export const BlackDiv = styled.div` color: rgb(0, 0, 0); `;

export const RightDiv = styled.div` text-align: right; `;

export const FlexDiv = styled.div` display: flex; `;
export const FlexColumnDiv = styled.div` display: flex; flex-direction: column; `;
export const FlexSpaceBetweenDiv = styled.div` display: flex; justify-content: space-between; `;
export const FlexSpaceAroundDiv = styled.div` display: flex; justify-content: space-around; `;
export const FlexBaselineDiv = styled.div` display: flex; align-items: baseline; `;
export const Flex1150Div = styled.div` flex: 1 1 50%; `;
export const Flex11Div = styled.div` flex: 1 1 auto; `;

export const ContainerDiv = styled.div`
    padding-bottom: 0.5rem;
    padding-left: 3rem;
    padding-right: 3rem;
`;

export const OverflowXDiv = styled.div` overflow-x: auto; max-width: 100vw; `;


export const CenterTitleDiv = props => {
    const { children } = props;

    return (
        <CenterMessageDiv>
            <Typography variant="h6">{children}</Typography>
        </CenterMessageDiv>
    );
};

/*
TODO: Realizar teste.

export const CenterMessageDiv = props => {
    const { children } = props;

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            {children}
        </div>
    );
};
*/


export const CenterMessageDiv = props => {
    const { children } = props;

    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            {children}
        </div>
    );
};

/////////////
// Buttons //
/////////////

const StyledPrimaryButton = styled(Button)`
    && {
        background-color: #0e4a64;
        color: #ffffff;
        text-transform: none;
        font-weight: 600;
        border-radius: 8px;
        box-shadow: none;
        padding: 6px 18px;
        &:hover { background-color: #0a3a50; box-shadow: 0 2px 8px rgba(14, 74, 100, 0.35); }
        &.Mui-disabled { background-color: #8ba7b3; color: #ffffff; }
    }
`;

const StyledSecondaryButton = styled(Button)`
    && {
        background-color: #ffffff;
        color: #0e4a64;
        text-transform: none;
        font-weight: 600;
        border-radius: 8px;
        border: 1px solid #0e4a64;
        box-shadow: none;
        padding: 6px 18px;
        &:hover { background-color: #eef4f7; border-color: #0a3a50; }
    }
`;

const StyledTextButton = styled(Button)`
    && {
        color: #0e4a64;
        text-transform: none;
        font-weight: 600;
        &:hover { background-color: rgba(14, 74, 100, 0.08); }
    }
`;

export const PrimaryButton = props => (<StyledPrimaryButton variant="contained" disableElevation {...props} />);

export const SecondaryButton = props => (<StyledSecondaryButton variant="outlined" {...props} />);

export const SecondaryTextButton = props => (<StyledTextButton variant="text" {...props} />);

export function formatMainDescription (main, description) {
    return (
        <React.Fragment>
            <MainDiv>{main}</MainDiv>
            <SubDiv>{description}</SubDiv>
        </React.Fragment>
    )
}

